<template>
	<div>
		<autopublish-widget :publish="published" :publish-date="date" @autopublish="date=$event"></autopublish-widget>
		<input type="hidden" name="publish[publish_date]" v-model="date" />
	</div>
</template>

<script>
	export default {
		props: {
			published: Boolean,
			publish: String,
		},
		data: function() {
			return {
				date: this._props.publish || null,
			};
		}
	};
</script>